import { FC } from 'react'

import { DEVICE_PLATFORMS } from '@/constants/devicePlatforms'
import { DevicePlatform } from '@/types/devicePlatform'

import { Autocomplete } from '../Autocomplete'

export const USER_AGENT_LABEL = 'User Agent'
export const USER_AGENT_AUTOCOMPLETE_ID = 'user-agent-autocomplete'

type Props = {
  value: DevicePlatform | null
  onChange: (value: DevicePlatform | null) => void
  label?: string
  testId?: string
  getOptionId?: (option: DevicePlatform) => string
}

export const UserAgentAutocomplete: FC<Props> = ({ ...props }) => {
  return (
    <Autocomplete
      label={USER_AGENT_LABEL}
      testId={USER_AGENT_AUTOCOMPLETE_ID}
      {...props}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, platform) => option.value === platform.value}
      groupBy={(option) => option.kind}
      options={DEVICE_PLATFORMS}
    />
  )
}
